import { Route } from "react-router";
import {
  COPY_DIET,
  DIET,
  DIETS,
  EDIT_DIET,
  EDIT_DIET_PRODUCTS,
  EDIT_DIET_RECIPES,
  EDIT_DIET_SETTINGS,
  EDIT_DIET_TAGS,
} from "@routes/routes";
import {
  DietClonePage,
  DietCreatorPage,
  DietCreatorProductsPage,
  DietCreatorRecipesPage,
  DietCreatorSettingsPage,
  DietCreatorTagsPage,
  DietPage,
  DietsPage,
} from "@routes/lazyPages";

/** Diets — list, creator tabs and preview. */
export const dietRoutes = (
  <>
    <Route path={DIETS} lazy={DietsPage} />

    <Route path={EDIT_DIET} lazy={DietCreatorPage}>
      <Route path={EDIT_DIET_SETTINGS} lazy={DietCreatorSettingsPage} />
      <Route path={EDIT_DIET_RECIPES} lazy={DietCreatorRecipesPage} />
      <Route path={EDIT_DIET_PRODUCTS} lazy={DietCreatorProductsPage} />
      <Route path={EDIT_DIET_TAGS} lazy={DietCreatorTagsPage} />
    </Route>

    <Route path={COPY_DIET} lazy={DietClonePage} />

    <Route path={DIET} lazy={DietPage} />
  </>
);
